import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight, Briefcase, Calendar } from "lucide-react";
import EmployerLogo from "./EmployerLogo";

const fmtSalary = (v) => {
  if (v.salary_min && v.salary_max) return `£${v.salary_min.toLocaleString()} – £${v.salary_max.toLocaleString()}`;
  if (v.salary_min) return `From £${v.salary_min.toLocaleString()}`;
  return "Salary on application";
};

export default function JobCard({ vacancy, compact = false }) {
  const featured = vacancy.featured;
  return (
    <Link
      to={`/vacancies/${vacancy.id}`}
      data-testid={`job-card-${vacancy.id}`}
      className={`group block paper-card p-6 ${featured ? "!border-sky/50 !bg-featured" : ""}`}
    >
      <div className="flex items-start gap-4">
        <EmployerLogo name={vacancy.employer_name} override={vacancy.employer_logo} size={44} className="shrink-0 mt-1" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-3 flex-wrap">
            {featured && (
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-sky text-nav text-[10px] font-bold uppercase tracking-[0.14em] rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-nav" /> Featured
              </span>
            )}
            <span className="text-[10px] uppercase tracking-[0.16em] text-slate font-mono font-semibold px-2 py-1 rounded border border-line">
              {vacancy.role_category.replace("-", " ")}
            </span>
          </div>
          <h3 className={`font-display text-ice ${compact ? "text-lg" : "text-xl md:text-2xl"} leading-[1.18] tracking-[-0.018em] font-bold`}>
            {vacancy.title}
          </h3>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[13px] text-slate">
            <span className="font-semibold text-ice">{vacancy.employer_name}</span>
            <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-sky" /> {vacancy.location}</span>
            <span className="inline-flex items-center gap-1.5"><Briefcase className="w-3.5 h-3.5 text-sky" /> {vacancy.employment_type}</span>
            {(vacancy.closing_date || vacancy.expiry_date) && (
              <span className="inline-flex items-center gap-1.5 text-slate/90"><Calendar className="w-3.5 h-3.5 text-sky" /> Closes {vacancy.closing_date || vacancy.expiry_date}</span>
            )}
          </div>
          {!compact && vacancy.description && (
            <p className="mt-4 text-[14px] text-slate leading-relaxed line-clamp-2 max-w-[60ch]">{vacancy.description}</p>
          )}
          <div className="mt-5 pt-4 border-t border-line flex items-center justify-between">
            <div className="font-mono text-[13px] text-sky font-semibold">{fmtSalary(vacancy)}</div>
            <ArrowUpRight className="w-5 h-5 text-slate group-hover:text-sky group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
          </div>
        </div>
      </div>
    </Link>
  );
}
